import { useEffect, useState } from "react";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import { useAuth } from "../../context/AuthContext";
import { api, errorMessage } from "../../lib/api";
import { toast } from "sonner";

export default function Profile() {
    const { user, refresh } = useAuth();
    const [catalog, setCatalog] = useState(null);
    const [demo, setDemo] = useState(user?.demographics || {});
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        api.get("/catalog/demographics").then((r) => setCatalog(r.data));
    }, []);
    useEffect(() => { setDemo(user?.demographics || {}); }, [user]);

    const set = (k, v) => setDemo((d) => ({ ...d, [k]: v }));
    const toggle = (k, v) => {
        const arr = Array.isArray(demo[k]) ? demo[k] : [];
        set(k, arr.includes(v) ? arr.filter((x) => x !== v) : [...arr, v]);
    };

    const save = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.put("/users/me/profile", demo);
            toast.success("Profile saved");
            await refresh();
        } catch (e) {
            toast.error(errorMessage(e));
        } finally {
            setSubmitting(false);
        }
    };

    if (!catalog) return <div className="min-h-screen flex items-center justify-center text-xs font-mono">LOADING…</div>;

    return (
        <div className="bg-paper min-h-screen">
            <Navbar />
            <main className="max-w-3xl mx-auto px-6 py-12">
                <p className="eyebrow mb-2">PROFILE</p>
                <h1 className="h2 mb-2">Demographics & qualifications</h1>
                <p className="text-ink-600 text-sm mb-8">The more we know, the better we match. Edit anything any time.</p>

                <form onSubmit={save} className="space-y-6">
                    <div className="grid sm:grid-cols-2 gap-5">
                        <Field label="Date of birth">
                            <input type="date" className="input-base" value={demo.dob || ""} onChange={(e) => set("dob", e.target.value)} data-testid="prof-dob" />
                        </Field>
                        <Select label="Gender" value={demo.gender} onChange={(v) => set("gender", v)} options={catalog.genders} testid="prof-gender" />
                        <Select label="Region / state" value={demo.region} onChange={(v) => set("region", v)} options={user?.country === "Canada" ? catalog.ca_provinces : catalog.us_states} testid="prof-region" />
                        <Field label="City"><input className="input-base" value={demo.city || ""} onChange={(e) => set("city", e.target.value)} data-testid="prof-city" /></Field>
                        <Select label="Education" value={demo.education} onChange={(v) => set("education", v)} options={catalog.education} testid="prof-education" />
                        <Select label="Employment" value={demo.employment} onChange={(v) => set("employment", v)} options={catalog.employment} testid="prof-employment" />
                        <Select label="Income" value={demo.income_range} onChange={(v) => set("income_range", v)} options={catalog.income_ranges} testid="prof-income" />
                        <Select label="Marital status" value={demo.marital_status} onChange={(v) => set("marital_status", v)} options={catalog.marital_status} testid="prof-marital" />
                        <Field label="Household size">
                            <input type="number" min={1} className="input-base" value={demo.household_size || ""} onChange={(e) => set("household_size", Number(e.target.value))} data-testid="prof-household" />
                        </Field>
                        <Field label="Has kids">
                            <select className="input-base" value={demo.has_kids === true ? "yes" : demo.has_kids === false ? "no" : ""} onChange={(e) => set("has_kids", e.target.value === "yes" ? true : e.target.value === "no" ? false : null)} data-testid="prof-haskids">
                                <option value="">—</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </Field>
                        <Select label="Ethnicity" value={demo.ethnicity} onChange={(v) => set("ethnicity", v)} options={catalog.ethnicities} testid="prof-ethnicity" />
                    </div>

                    <Field label="Interests (tap to toggle)">
                        <div className="flex flex-wrap gap-2 mt-1">
                            {catalog.interests.map((i) => {
                                const on = (demo.interests || []).includes(i);
                                return (
                                    <button type="button" key={i} onClick={() => toggle("interests", i)} className={`btn ${on ? "btn-ink" : "btn-outline"} text-xs py-2 px-3`} data-testid={`interest-${i}`}>
                                        {i}
                                    </button>
                                );
                            })}
                        </div>
                    </Field>

                    <button type="submit" disabled={submitting} className="btn btn-ink" data-testid="profile-save-btn">
                        {submitting ? "Saving…" : "Save profile"}
                    </button>
                </form>
            </main>
            <Footer />
        </div>
    );
}

function Field({ label, children }) {
    return (
        <div>
            <label className="eyebrow block mb-2">{label}</label>
            {children}
        </div>
    );
}

function Select({ label, value, onChange, options, testid }) {
    return (
        <Field label={label}>
            <select className="input-base" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
                <option value="">—</option>
                {options.map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
        </Field>
    );
}
